<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['hotel_booking_allotments.menu'])">
  <div class="d-flex justify-content-between align-items-center">
    <div>
      <h5 class="title-secondary">
        {{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.TITLE' | translate }}
      </h5>
    </div>
    <div class="d-flex align-items-end" [formGroup]="form">
      <div>
        <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
          {{ 'CLEAR_FILTERS' | translate }}
        </button>
      </div>

      <div class="additional-filter-holder relative">
        <app-event-select
          [parentFormGroup]="form"
          [onlyIncoming]="false"
          [onlyActive]="false"
          [includes]="'venue'"
          (select)="eventFilterChange()"
        ></app-event-select>
      </div>

      <div class="additional-filter-holder-xs relative ms-2">
        <label>{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.RADIUS' | translate }}</label>
        <input (keyup)="eventFilterChange()" type="number" class="form-control" formControlName="radius" />
      </div>

      <div class="additional-filter-holder-xs relative ms-2 me-2">
        <label>{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.ADDITIONAL_DAYS' | translate }}</label>
        <input (keyup)="eventFilterChange()" type="number" class="form-control" formControlName="additional_days" />
      </div>

      <div>
        <button
          [disabled]="!this.form.get('event').value || !this.form.get('radius').value"
          type="button"
          class="btn btn-success btn-input"
          (click)="loadData(state, true)"
        >
          {{ 'HOTELS.HOTELS_LIST.SEARCH' | translate }}
        </button>

        <!--        <button type="button" class="btn btn-danger btn-input" (click)="clearFilters()">-->
        <!--          {{ 'HOTELS.HOTELS_LIST.CLEAR_FILTERS' | translate }}-->
        <!--        </button>-->
      </div>

      <div class="ms-3">
        <button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotel_bookings.store']
            )
          "
          type="button"
          class="btn btn-secondary btn-input"
          (click)="add()"
        >
          {{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.ADD' | translate }}
        </button>
      </div>
    </div>
  </div>
  <kendo-grid
    [data]="data"
    [pageSize]="hotelBookingsRoomsResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'ADV_Bookings', grid)"
    [loading]="loader"
  >
    <kendo-grid-column
      [width]="55"
      class="text-center"
      headerClass="text-center"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.ID' | translate }}"
      filter="numeric"
      [width]="100"
      format="0"
      [hidden]="isHiddenColumn('id', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="hotel.name"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.HOTEL' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('hotel.name')"
      width="300"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <a [routerLink]="'/hotel-bookings/view'" [queryParams]="{ id: dataItem.booking.id }" target="_blank">
          {{ dataItem?.hotel?.name }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="hotel.stars"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.STARS' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('hotel.stars')"
      width="65"
      [columnMenu]="false"
      format="0"
    ></kendo-grid-column>

    <kendo-grid-column
      field="booking.events.name"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.EVENTS' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('booking.events.name')"
      [sortable]="false"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-event-select [filter]="filter" [field]="'event_id'"></app-kendo-event-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div *ngFor="let event of dataItem.booking?.events; let i = index">
          <a [routerLink]="['/events/view']" [queryParams]="{ id: event.id }" target="_blank">
            {{ event.formattedName }}
          </a>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.company.abbreviation"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.COMPANY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('booking.company.abbreviation', true)"
      [width]="85"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-company-select [filter]="filter" [field]="'booking.company_id'"></app-kendo-company-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        <a
          [routerLink]="['/settings/companies/view']"
          [queryParams]="{ id: dataItem?.booking.company_id }"
          target="_blank"
        >
          {{ dataItem?.booking?.company?.shortName }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.property.value"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.PROPERTY' | translate }}"
      [hidden]="isHiddenColumn('booking.property.value')"
      width="110"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select
          [groupType]="'booking_properties'"
          [field]="'booking.property_id'"
          [filter]="filter"
        ></app-kendo-type-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.booking.property"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="bookingTags"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.TAGS' | translate }}"
      filter="text"
      [sortable]="false"
      [hidden]="isHiddenColumn('bookingTags', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <app-kendo-tag-select
          [filter]="filter"
          [model]="LaravelModelsEnum.HOTELBOOKING"
          field="bookingTags"
        ></app-kendo-tag-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span *ngFor="let tag of dataItem?.booking?.tags; let i = index">
          {{ tag }}<span *ngIf="i !== dataItem?.booking?.tags?.length - 1">, </span>
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.cancellation_terms.value"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.CANCELLATION_TERMS' | translate }}"
      [hidden]="isHiddenColumn('booking.cancellation_terms.value')"
      width="140"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select
          [groupType]="'booking_cancellation_terms'"
          [field]="'booking.cancellation_terms_id'"
          [filter]="filter"
        ></app-kendo-type-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.booking.cancellation_terms"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.supplier_id"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.SUPPLIER' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('booking.supplier_id', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-supplier-select [filter]="filter" [field]="'booking.supplier_id'"></app-kendo-supplier-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.booking?.supplier?.name }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="hotel.city.country.name"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.COUNTRY' | translate }}"
      [hidden]="isHiddenColumn('hotel.city.country.name', true)"
      width="100"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-country-select [field]="'hotel.city.country_id'" [filter]="filter"></app-kendo-country-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-country-box [country]="dataItem?.hotel?.city?.country"></app-country-box>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="hotel.city.name"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.CITY' | translate }}"
      [hidden]="isHiddenColumn('hotel.city.name')"
      width="100"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-city-select [filter]="filter" [field]="'hotel.city_id'"></app-kendo-city-select>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      *ngIf="apiQuery.hasFilter('event_id')"
      field="hotel.venue.distance"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.KM_TO_FAIR' | translate }}"
      [hidden]="isHiddenColumn('distance_to_fair')"
      [filterable]="true"
      [sortable]="true"
      width="80"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false" operator="lte">
        </kendo-grid-numeric-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.hotel.venue?.distance }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="hotel.distance_to_center"
      filter="numeric"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.DISTANCE_TO_CENTER_SHORT' | translate }}"
      [hidden]="isHiddenColumn('hotel.distance_to_center')"
      width="80"
    ></kendo-grid-column>

    <kendo-grid-column
      field="available_rooms"
      filter="numeric"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.ROOMS_COUNT_SHORT' | translate }}"
      [hidden]="isHiddenColumn('available_rooms')"
      width="65"
      [columnMenu]="false"
      format="0"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" operator="gte">
        </kendo-grid-numeric-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="type.value"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.TYPE' | translate }}"
      [hidden]="isHiddenColumn('type.value')"
      width="100"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select [groupType]="'rooms'" [filter]="filter"></app-kendo-type-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.type"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="meal_plan.value"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.MEAL_PLAN_SHORT' | translate }}"
      [hidden]="isHiddenColumn('meal_plan.value')"
      width="65"
      [columnMenu]="false"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select
          [groupType]="'room_meal_plans'"
          [field]="'meal_plan_id'"
          [filter]="filter"
        ></app-kendo-type-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.meal_plan"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [hidden]="isHiddenColumn('created_at', true)"
      field="created_at"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.CREATED_AT' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.created_at.getDate() }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="check_in"
      filter="date"
      format="{0:dd/MM/yyyy}"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.CHECK_IN' | translate }}"
      [hidden]="isHiddenColumn('check_in')"
      width="140"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.check_in | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="check_out"
      filter="date"
      format="{0:dd/MM/yyyy}"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.CHECK_OUT' | translate }}"
      [hidden]="isHiddenColumn('check_out')"
      width="140"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.check_out | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.contracting_agent.fake_first_name"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.CONTRACTING_AGENT' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('booking.contracting_agent.fake_first_name', true)"
      [width]="150"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-user-select
          [filter]="filter"
          [roleType]="[UserRoleType.CONTRACTING_AGENT]"
          [field]="'booking.contracting_agent_id'"
        ></app-kendo-user-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.booking?.contracting_agent?.names }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.reservation_agent.fake_first_name"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.RESERVATION_AGENT' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('booking.reservation_agent.fake_first_name', true)"
      [width]="150"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-user-select
          [filter]="filter"
          [roleType]="[UserRoleType.RESERVATION_AGENT]"
          [field]="'booking.reservation_agent_id'"
        ></app-kendo-user-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.booking?.reservation_agent?.names }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.amendment_agent.fake_first_name"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.AMENDMENT_AGENT' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('booking.amendment_agent.fake_first_name', false)"
      [width]="100"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-user-select
          [filter]="filter"
          [roleType]="[UserRoleType.AMENDMENT_AGENT]"
          [field]="'booking.amendment_agent_id'"
        ></app-kendo-user-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.booking?.amendment_agent?.names }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.cancellation_deadline"
      filter="date"
      format="{0:dd/MM/yyyy}"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.CANCELLATION_DEADLINE_SHORT' | translate }}"
      [hidden]="isHiddenColumn('booking.cancellation_deadline', true)"
      width="140"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.booking?.cancellation_deadline | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="net_price_eur_avg"
      filter="numeric"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.NET_PRICE_AVG' | translate }}"
      [hidden]="isHiddenColumn('net_price_eur_avg')"
      width="95"
      [columnMenu]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.net_price_eur_avg | number : '1.2-2' }}
        {{ 'DEFAULT_CURRENCY' | translate }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="price_avg"
      filter="numeric"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.PRICE_AVG' | translate }}"
      [hidden]="isHiddenColumn('price_avg', true)"
      width="95"
      [columnMenu]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.price_avg | number : '1.2-2' }}
        {{ 'DEFAULT_CURRENCY' | translate }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="margin_avg"
      filter="numeric"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.MARGIN_AVG' | translate }}"
      [hidden]="isHiddenColumn('margin_avg', true)"
      width="95"
      [columnMenu]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.margin_avg | number : '1.2-2' }} {{ 'DEFAULT_CURRENCY' | translate }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="ref_number"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.ROOMS_REF_NUMBER' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('ref_number', true)"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="commission"
      [filterable]="false"
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.COMMISSION_AVG' | translate }}"
      [hidden]="isHiddenColumn('commission', true)"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex"> ?????????????? </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.ACTIONS' | translate }}"
      [width]="60"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-preview-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING,
                UserRoleType.EXTERNAL_PARTNER,
                UserRoleType.EXTERNAL_PARTNER_LEAD
              ],
              ['hotel_bookings.show']
            )
          "
          [link]="['/hotel-bookings/view']"
          [params]="{ id: dataItem.booking?.id }"
        ></app-preview-button>

        <app-edit-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotel_bookings.show']
            )
          "
          (click)="edit(dataItem.booking)"
        >
        </app-edit-button>

        <a
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotel_booking_cancellations.store']
            )
          "
          class="btn btn-warning btn-ico"
          [routerLink]="['/hotel-booking-cancellations/view']"
          [queryParams]="{ booking_id: dataItem.booking.id }"
          [ngbTooltip]="'HOTELS_BOOKINGS.HOTEL_BOOKINGS_ROOMS_LIST.CREATE_CANCELLATION' | translate"
          container="body"
        >
          <i class="fal fa-ban"></i>
        </a>

        <app-delete-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotel_bookings.destroy']
            )
          "
          [swal]="{}"
          (confirm)="delete(dataItem.booking)"
        >
        </app-delete-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
